export const currentLanguage = { ref: null };
